import { IconMeatball } from '@consta/icons/IconMeatball'
import { Button } from '@consta/uikit/Button'
import { Text } from '@consta/uikit/Text'
import { withTooltip } from '@consta/uikit/withTooltip'
import cn from 'classnames'
import type { Nullable } from 'common/types'
import type { FC, MouseEventHandler, ReactElement } from 'react'
import { useRef } from 'react'

import type { ChangeMenuVisibilityFuncType, ObjectTreeNodeLabel } from '../types'
import css from './CustomLabel.css'
import { isDraftDetailed } from './helpers'
import { TooltipContent } from './TooltipContent'

const TextWithTooltip = withTooltip({ direction: 'downCenter' })(Text)

type PropsType = {
  objectTreeNode: ObjectTreeNodeLabel
  icon?: ReactElement
  check?: ReactElement
  changeMenuVisibility?: ChangeMenuVisibilityFuncType
  isLeaf?: boolean
}

export const CustomLabel: FC<PropsType> = ({
  objectTreeNode,
  icon,
  check,
  changeMenuVisibility,
  isLeaf,
}) => {
  const anchor = useRef<Nullable<HTMLElement>>(null)
  const refBtn = useRef<Nullable<HTMLButtonElement>>(null)
  const isBtnContextMenu = Boolean(changeMenuVisibility)

  const { isDraft } = isDraftDetailed(objectTreeNode)

  const textView = isDraft ? 'secondary' : 'primary'

  const onChangeMenuVisibility = () =>
    changeMenuVisibility?.(refBtn, {
      ...objectTreeNode,
      uid: objectTreeNode.uid ?? '',
      elementType: objectTreeNode.elementType ?? 'unknown',
      state: objectTreeNode.state ?? 'Draft',
    })

  const onClickLabel: MouseEventHandler<HTMLDivElement> = e => {
    e.preventDefault()
    onChangeMenuVisibility()
  }

  const textClass = cn(css.title, { [css.draftElement]: isDraft })
  const treeMargin = cn({ [css.treeMargin]: isLeaf })

  return (
    <div
      className={`${css.container} ${treeMargin}`}
      data-testid={objectTreeNode.uid}
      onContextMenu={onClickLabel}>
      {!!(icon ?? check) && (
        <div className={css.wrapper}>
          {check}
          <div className={css.icon}>{icon}</div>
        </div>
      )}
      <TextWithTooltip
        ref={anchor}
        className={textClass}
        as="span"
        view={textView}
        size="s"
        truncate={true}
        tooltipProps={{
          tooltipContent: <TooltipContent objectTreeNode={objectTreeNode} />,
        }}>
        {objectTreeNode.name}
      </TextWithTooltip>

      {!!isBtnContextMenu && (
        <Button
          ref={refBtn}
          view="clear"
          size="xs"
          onlyIcon={true}
          iconLeft={IconMeatball}
          iconSize="xs"
          className={css.btnContextMenu}
          onClick={onChangeMenuVisibility}
        />
      )}
    </div>
  )
}
